import React from 'react';
import { FlexibleHeroWrapperProps } from './FlexibleHero.props';
import { PageSection, PageSectionContent } from '@greystar/designsystem';
import styles from './flexibleHero.module.scss';

const FlexibleHeroWrapper = (props: FlexibleHeroWrapperProps) => {
  return (
    <div className={props.isLocationGuidePage ? styles.flexibleHeroWrapper : ''}>
      <PageSection
        isTopFlushed={props.isLocationGuidePage}
        isBottomFlushed={props.isLocationGuidePage}
        topColour={props.backgroundColours}
      >
        <PageSectionContent>{props.children}</PageSectionContent>
      </PageSection>
    </div>
  );
};

export default FlexibleHeroWrapper;
